export default __webpack_public_path__ + "static/media/3.9a7242cb.svg";